// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var LogIO = require("../LogIO.bs.js");
var Plaid = require("plaid");
var TypeUtils = require("../types/TypeUtils.bs.js");

var ClientId = TypeUtils.MakeOpaqueStringType({});

var Secret = TypeUtils.MakeOpaqueStringType({});

var Key = TypeUtils.MakeOpaqueStringType({});

var PublicToken = TypeUtils.MakeOpaqueStringType({});

var AccessToken = TypeUtils.MakeOpaqueStringType({});

var AccountId = TypeUtils.MakeOpaqueStringType({});

function make(prim) {
  return {
          access_token: prim
        };
}

var ExchangePublicTokenResponse = {
  make: make
};

function make$1(prim) {
  return {
          stripe_bank_account_token: prim
        };
}

var CreateStripeTokenResponse = {
  make: make$1
};

function exchangePublicToken(publicToken, t) {
  return LogIO.logMessage(undefined, "Plaid.exchangePublicToken", "succeeded")(LogIO.logExn(undefined, "Plaid.exchangePublicToken")(LogIO.fromPromiseWithJsExn(function (param) {
                      return t.exchangePublicToken(publicToken);
                    })));
}

function createStripeToken(accessToken, accountId, t) {
  return LogIO.logMessage(undefined, "Plaid.createStripeToken", "succeeded")(LogIO.logExn(undefined, "Plaid.createStripeToken")(LogIO.fromPromiseWithJsExn(function (param) {
                      return t.createStripeToken(accessToken, accountId);
                    })));
}

function Plaid_make(prim, prim$1, prim$2, prim$3) {
  return new Plaid.Client(prim, prim$1, prim$2, prim$3, {"version": "2018-05-22"});
}

var Plaid$1 = {
  make: Plaid_make,
  exchangePublicToken: exchangePublicToken,
  createStripeToken: createStripeToken
};

exports.ClientId = ClientId;
exports.Secret = Secret;
exports.Key = Key;
exports.PublicToken = PublicToken;
exports.AccessToken = AccessToken;
exports.AccountId = AccountId;
exports.ExchangePublicTokenResponse = ExchangePublicTokenResponse;
exports.CreateStripeTokenResponse = CreateStripeTokenResponse;
exports.Plaid = Plaid$1;
/* ClientId Not a pure module */
